const routes = {
  //======================== Login And Dashboard, Settings ========
  Login: "/",
  //======================== Projects ========
  ProjectPin: "/projectsPin",
  Projects: "/projects",
};
export default routes;
